export const PhoneAreaCodesData = [
  { title: '+32', value: '+32' },
  { title: '+33', value: '+33' }
]
